export const GET_INGRIDIENTS_REQUEST: 'GET_INGRIDIENTS_REQUEST' = 'GET_INGRIDIENTS_REQUEST';
export const GET_INGRIDIENTS_SUCCESS: 'GET_INGRIDIENTS_SUCCESS' = 'GET_INGRIDIENTS_SUCCESS';
export const GET_INGRIDIENTS_ERROR: 'GET_INGRIDIENTS_ERROR' = 'GET_INGRIDIENTS_ERROR';

export const ORDER_REQUEST: 'ORDER_REQUEST' = 'ORDER_REQUEST';
export const ORDER_SUCCESS: 'ORDER_SUCCESS' = 'ORDER_SUCCESS';
export const ORDER_ERROR: 'ORDER_ERROR' = 'ORDER_ERROR';

export const UPDATE_USER_DATA_REQUEST: 'UPDATE_USER_DATA_REQUEST' = 'UPDATE_USER_DATA_REQUEST';
export const UPDATE_USER_DATA_SUCCESS: 'UPDATE_USER_DATA_SUCCESS' = 'UPDATE_USER_DATA_SUCCESS';
export const UPDATE_USER_DATA_ERROR: 'UPDATE_USER_DATA_ERROR' = 'UPDATE_USER_DATA_ERROR';

export const FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST' = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS' = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR' = 'FORGOT_PASSWORD_ERROR';

export const GET_PROFILE_DATA_REQUEST: 'GET_PROFILE_DATA_REQUEST' = 'GET_PROFILE_DATA_REQUEST';
export const GET_PROFILE_DATA_SUCCESS: 'GET_PROFILE_DATA_SUCCESS' = 'GET_PROFILE_DATA_SUCCESS';
export const GET_PROFILE_DATA_ERROR: 'GET_PROFILE_DATA_ERROR' = 'GET_PROFILE_DATA_ERROR';

export const RESET_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST' = 'FORGOT_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS' = 'FORGOT_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR' = 'FORGOT_PASSWORD_ERROR';

export const UPDATE_TOKEN_REQUEST: 'UPDATE_TOKEN_REQUEST' = 'UPDATE_TOKEN_REQUEST';
export const UPDATE_TOKEN_SUCCESS: 'UPDATE_TOKEN_SUCCESS' = 'UPDATE_TOKEN_SUCCESS';
export const UPDATE_TOKEN_ERROR: 'UPDATE_TOKEN_ERROR' = 'UPDATE_TOKEN_ERROR';

export const USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST' = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS' = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR: 'USER_LOGIN_ERROR' = 'USER_LOGIN_ERROR';

export const USER_LOGOUT_REQUEST: 'USER_LOGOUT_REQUEST' = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS' = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_ERROR: 'USER_LOGOUT_ERROR' = 'USER_LOGOUT_ERROR';

export const USER_REGISTRATION_REQUEST: 'USER_REGISTRATION_REQUEST' = 'USER_REGISTRATION_REQUEST';
export const USER_REGISTRATION_SUCCESS: 'USER_REGISTRATION_SUCCESS' = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_ERROR: 'USER_REGISTRATION_ERROR' = 'USER_REGISTRATION_ERROR';

export const WS_CONNECTION_ALL_ORDERS_START: 'WS_CONNECTION_ALL_ORDERS_START' = 'WS_CONNECTION_ALL_ORDERS_START';
export const WS_CONNECTION_ALL_ORDERS_STOP: 'WS_CONNECTION_ALL_ORDERS_STOP' = 'WS_CONNECTION_ALL_ORDERS_STOP';

export const WS_CONNECTION__ALL_ORDERS_SUCCESS: 'WS_CONNECTION__ALL_ORDERS_SUCCESS' = 'WS_CONNECTION__ALL_ORDERS_SUCCESS';
export const WS_CONNECTION__ALL_ORDERS_ERROR: 'WS_CONNECTION__ALL_ORDERS_ERROR' = 'WS_CONNECTION__ALL_ORDERS_ERROR';
export const WS_CONNECTION__ALL_ORDERS_CLOSED: 'WS_CONNECTION__ALL_ORDERS_CLOSED' = 'WS_CONNECTION__ALL_ORDERS_CLOSED';
export const WS_GET_ALL_ORDERS: 'WS_GET_ALL_ORDERS' = 'WS_GET_ALL_ORDERS';


export const WS_CONNECTION_USER_ORDERS_START: 'WS_CONNECTION_USER_ORDERS_START' = 'WS_CONNECTION_USER_ORDERS_START';
export const WS_CONNECTION_USER_ORDERS_STOP: 'WS_CONNECTION_USER_ORDERS_STOP' = 'WS_CONNECTION_USER_ORDERS_STOP';

export const WS_CONNECTION__USER_ORDERS_SUCCESS: 'WS_CONNECTION__USER_ORDERS_SUCCESS' = 'WS_CONNECTION__USER_ORDERS_SUCCESS';
export const WS_CONNECTION__USER_ORDERS_ERROR: 'WS_CONNECTION__USER_ORDERS_ERROR' = 'WS_CONNECTION__USER_ORDERS_ERROR';
export const WS_CONNECTION__USER_ORDERS_CLOSED: 'WS_CONNECTION__USER_ORDERS_CLOSED' = 'WS_CONNECTION__USER_ORDERS_CLOSED';
export const WS_GET_USER_ORDERS: 'WS_GET_USER_ORDERS' = 'WS_GET_USER_ORDERS';

export const GET_CURRENT_ORDER_REQUEST: 'GET_CURRENT_ORDER_REQUEST' = 'GET_CURRENT_ORDER_REQUEST';
export const GET_CURRENT_ORDER_SUCCESS: 'GET_CURRENT_ORDER_SUCCESS' = 'GET_CURRENT_ORDER_SUCCESS';
export const GET_CURRENT_ORDER_ERROR: 'GET_CURRENT_ORDER_ERROR' = 'GET_CURRENT_ORDER_ERROR';
